<template>
  <div class="AlarmRecordContainer">
    <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess"
      :wrapperClosable="false" direction="rtl" ref="drawer">
      <alarm-drawer :editData="selectData" v-if="drawerShow"></alarm-drawer>
    </el-drawer>
    <div class="query newDate">
      <span>
        <el-date-picker v-model="creatTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" align="right">
        </el-date-picker>
        <!-- <el-select v-model="devtypeid" placeholder="设备类型" clearable>
            <el-option v-for="item in devtypeoptions" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
          </el-select> -->
        <!-- <el-select v-model="zoneid" placeholder="报警区域" clearable>
            <el-option v-for="item in zoneoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
        <el-select v-model="handleState" placeholder="处理进度" clearable>
          <el-option v-for="item in handleoptions" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-input placeholder="请输入报警内容" v-model="content" style="width:170px;"></el-input>
        <!-- <el-select v-model="alarmLevel" placeholder="报警等级" clearable>
            <el-option v-for="item in leveloptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select> -->
        <!-- <el-select v-model="deviceType" placeholder="设备类型" clearable>
        <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
      </el-select> -->
        <el-button class="common" type="primary" size="medium" @click="serachData" icon="el-icon-search">查询</el-button>
        <!-- <button class="primaryBtn" @click="serachData">查询</button> -->
      </span>
      <!-- <button class="primaryBtn" @click="exportTable"><span style="color:#fff">报表导出</span></button> -->
    </div>
    <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading"
      :current-page="pagination.page" @currentChange="alarmCurrentChange" @sizeChange="alarmSizeChange">
      <!-- <el-table-column type="selection" width="50" border></el-table-column> -->
      <el-table-column type="index" label="#" width="60"></el-table-column>
      <el-table-column prop="deviceName" label="设备名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="deviceId" label="设备ID" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="deviceIMEI" label="设备IMEI" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="deviceType" label="设备种类" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div>{{
              typeOptions.find((e) => e.id === scope.row.deviceType).name
            }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="deviceRegistTo" label="设备注册至" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div>
            {{scope.row.deviceRegistTo == 0 ? 'X' : scope.row.deviceRegistTo == 1 ? 'L' : scope.row.deviceRegistTo == 2 ? 'D' : scope.row.deviceRegistTo == 4 ? 'Y' : 'other'}}
          </div>

        </template>
      </el-table-column>
      <el-table-column prop="deviceInstallLocation" label="设备安装位置" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createTime" label="报警时间" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="content" label="报警内容" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="isHandle" label="处理状态" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span
            :style="{background : scope.row.isHandle ? '#00b050' : '#ff0000', color:'#fff',padding:'1px 4px',borderRadius:'3px'}"
            :disabled="scope.row.isHandle">{{scope.row.isHandle ? '已处理' : '未处理'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="通知记录" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-button @click="seeClick(scope.row)" size="small" class="edit">查看</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="" label="操作" fixed="right" width="200px">
      <template slot-scope="scope">
        <el-button type="text" icon="el-icon-s-claim" v-if="!scope.row.isHandle" @click="dealDialog(scope.row)">处理</el-button>
      </template>
    </el-table-column> -->
    </border-table>
  </div>
</template>

<script>
import BorderTable from "@/views/deviceManagement/deviceDetails/BorderTable";
import AlarmDrawer from "@/components/alarmHistory/AlarmDrawer";
export default {
  components: {
    BorderTable,
    AlarmDrawer
  },
  props: {
    deviceImei: {
      type: String,
      default: () => {
        return null;
      }
    }
  },
  data () {
    return {
      fbdate: null,
      fedate: null,
      creatTime: [],
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: "最近一个月",
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }
        ]
      },
      // devtypeoptions: [],
      // zoneoptions: [],
      handleoptions: [{
        value: false,
        label: '未处理'
      },
      {
        value: true,
        label: '已处理'
      }
      ],
      // leveloptions: [{
      //     value: 1,
      //     label: '一级报警'
      //   },
      //   {
      //     value: 2,
      //     label: '二级报警'
      //   },
      //   {
      //     value: 3,
      //     label: '三级报警'
      //   }
      // ],
      selectedName: "",
      radio: "1",
      names: "",
      styleObject: {
        height: ""
      },
      tableLoading: false,
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      drawerShow: false,
      drawerTitle: "",
      drawerWidth: "500px",
      // devtypeid: '',
      // zoneid: null,
      handleState: '',
      // alarmLevel: null,
      handleType: '',
      selectData: {},
      params: {},
      paramdata: '',
      handleDrawerShow: false,
      handleId: '',
      alarmTime: '',
      content: '',
      policeContent: '',
      typeOptions: [],
      deviceType: '',
      deviceTypeList: ''
    }
  },
  created () {
    this.makeheight()
    this.getDeviceType()
    this.getDeviceTypeAll()
  },
  methods: {
    getDeviceType () {
      this.request.post('/front/device/type/query', {
        page: 1,
        pageSize: 1000
      }).then(res => {
        // console.log(res);
        if (res.code === 200) {
          this.deviceTypeList = res.data.data ? res.data.data : []
        } else if (res.code === 500) {
          this.deviceTypeList = []
          this.msg.warn(res.msg)
        }
      })
        .catch(error => {
          console.log(error)
        })
    },
    async getDeviceTypeAll () {
      const {
        code,
        data,
        msg
      } = await this.request.get("/front/device/class/all")
      if (code !== 200) {
        return
      }
      this.typeOptions = data
      this.reloadTable();
    },
    serachData () {
      //查询//查询
      this.content = this.content.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    alarmCurrentChange (val) {
      this.pagination.currentPage = val;
      this.reloadTable();
    },
    //表格展示条数变化时
    alarmSizeChange (val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    getCurrentYear () {
      // console.log(this.creatTime);
      if (this.creatTime != null && this.creatTime.length) {
        let date = new Date();
        let y = date.getFullYear();

        let date0 = this.creatTime[0];
        let y0 = date0.getFullYear();

        let date1 = this.creatTime[1];
        let y1 = date1.getFullYear();

        let date2 = this.creatTime[0];
        let y2 = this.formatDate(date2)
        let data3 = this.formatterDate(this.storage.getSession("sysStartTime"));
        let y3 = this.formatDate(data3)

        if (y0 > y) {
          this.msg.error('输入开始日期年份大于当前年份，请重新输入！')
        } else if (y1 > y) {
          this.msg.error('输入结束日期年份大于当前年份，请重新输入！')
        } else if (y3 > y2) {
          this.msg.error('选择时间小于系统开始时间，请重新输入！')
        } else {
          this.tableLoading = true
          this.fbdate = this.formatDate(this.creatTime[0]);
          this.fedate = this.formatDate(this.creatTime[1]);
          this.params = {
            "content": this.content,
            "startTime": this.fbdate,
            "endTime": this.fedate,
            "isHandle": this.handleState,
            "orgId": this.currentTreeId ? this.currentTreeId : this.storage.getSession("orgId"),
            "page": this.pagination.currentPage,
            "pageSize": this.pagination.pageSize,
            "sort": "createTime",
            "order": "desc",
            "imei": this.deviceImei,
            "type": this.deviceType
          }
          this.request.post("/front/alarm/record/query", this.params).then(res => {
            if (res.code == 200) {
              this.tableLoading = false
              this.dataList = res.data.data;
              this.pagination.total = res.data.totalCount;
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
              // this.msg.warn("查询月份的报警分表不存在")
            }
          }).catch(error => {
            console.log(error)
          })
        }
      } else {
        // this.msg.warn("请选择开始日期和结束日期！")
        this.params = {
          "content": this.content,
          "startTime": '',
          "endTime": '',
          "isHandle": this.handleState,
          "orgId": this.currentTreeId ? this.currentTreeId : this.storage.getSession("orgId"),
          "page": this.pagination.currentPage,
          "pageSize": this.pagination.pageSize,
          "sort": "createTime",
          "order": "desc",
          "imei": this.deviceImei,
          "type": this.deviceType
        }
        this.request.post("/front/alarm/record/query", this.params).then(res => {
          if (res.code == 200) {
            this.tableLoading = false
            this.dataList = res.data.data;
            this.pagination.total = res.data.totalCount;
          } else if (res.code == 500) {
            // this.msg.warn("查询月份的报警分表不存在")
            this.msg.warn(res.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    reloadTable () {
      this.getCurrentYear()
    },
    formatDate (d) {
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times = d.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec;
      return times;
    },
    formatterDate (date) {
      let result = new Date(date);
      return result;
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight (height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    seeClick (row) {
      this.drawerShow = true;
      this.drawerTitle = "通知记录";
      this.handleType = 'seeDetail';
      this.selectData = row;
    },
    //关闭抽屉
    closeMess () {
      this.loading = false;
    },
    exportTable () {
      this.$confirm('此操作将导出报表, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let getparams = "page=" + parseInt(this.pagination.currentPage) + "&pageSize=" + parseInt(this.pagination.pageSize);
        // if (this.devtypeid) {
        //   getparams += "&devicetypeid=" + this.devtypeid;
        // }
        // if (this.zoneid) {
        //   getparams += "&zoneId=" + this.zoneid;
        // }
        getparams += "&isHandle=" + this.handleState;
        if (this.content) {
          // console.log(this.content);
          getparams += "&content=" + this.content;
        }
        if (this.currentTreeId) {
          // console.log(this.currentTreeId);
          getparams += "&orgId=" + this.currentTreeId;
        }
        if (this.creatTime != undefined && this.creatTime.length) {
          if (this.creatTime[0]) {
            getparams += "&startTime=" + this.formatDate(this.creatTime[0])
          }
          if (this.creatTime[1]) {
            getparams += "&endTime=" + this.formatDate(this.creatTime[1])
          }
        } else {
          getparams += "&startTime= " + "&endTime= "
        }
        this.paramdata = getparams;
        window.open(this.baseUrlAddr + '/front/alarm/record/download?' + this.paramdata)
        this.msg.success('导出成功')
        return
      }).catch(() => {
        this.msg.info('已取消导出')
      });
    },
    // handleAlarm(row) {
    //   this.handleId = row.id;
    //   this.alarmTime = row.createTime;
    //   this.handleDrawerShow = true;
    //   this.fbdate = this.formatDate(this.creatTime[0]);
    //   this.fedate = this.formatDate(this.creatTime[1]);
    //   this.drawerTitle = row.handleStatus === '未处理' ? "报警处理" : "处理结果";
    //   this.handleType = row.handleStatus === '未处理' ? "handle" : "result";
    // },
    dealDialog (row) {
      this.$confirm('此操作将处理报警, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // console.log(`row`, row)
        this.handleDrawerShow = true;
        this.handleId = row.id
        this.policeContent = row.content
        this.drawerTitle = "报警处理";
        // this.request.post("/front/alarm/record/handle?id=" + row.id).then(res => { //报警处理
        //   console.log(res)
        //   if (res.code == 200) {
        //     this.reloadTable()
        //   } else if (res.code == 500) {
        //     this.msg.warn(res.msg);
        //   }
        // }).catch(error => {
        //   console.log(error)
        // })
      }).catch(() => {
        this.msg.info('已取消处理')
      });
    },
    handleConfirm () {
      this.handleDrawerShow = false;
      this.reloadTable()
    }
  }
}
</script>

<style lang="scss">
.AlarmRecordContainer {
  .query {
    padding-bottom: 15px;

    .primaryBtn {
      width: 82px;
      height: 36px;
      cursor: pointer;
      margin-right: 20px;
      font-size: 14px;
      line-height: 36px;
      border: 0;
      color: #FFFFFF;
      background: #1089FF;
      border-radius: 2px;

      &:hover {
        background: #0774e0;
      }
    }

    .el-input {
      width: 380px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
  }

  .newDate {

    .el-date-editor--datetimerange.el-input,
    .el-date-editor--datetimerange.el-input__inner {
      width: 380px;
    }
  }
}

.exportBtn {
  background: #2177E6;
  color: #fff;
  padding: 11px 15px;
  height: 36px;
  line-height: 36px;
  border: none;
  font-size: 14px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin-right: 10px;
}
</style>
